import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from './translate.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[translate]',
  standalone: false,
})
export class TranslateDirective implements OnInit, OnDestroy {
  @Input('translate') key!: string;
  private sub!: Subscription;

  constructor(
    private el: ElementRef,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.setTranslation();
    this.sub = this.translate.onLangChange.subscribe(() => {

      setTimeout(() => {
        this.setTranslation();
      }, 0)
    }
    );
  }

  private setTranslation() {
    try {
      const translated = this.translate.get(
        this.key || this.el.nativeElement.innerText,
      );

      this.el.nativeElement.innerText = translated;
    } catch (error) {
      console.log('Error in translate directive', error);

    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
